import React from "react";
import { Box } from "@chakra-ui/react";

const EnvironmentBanner = () => {
  const isStaging = process.env.REACT_APP_ENV === "staging";
  if (!isStaging) return null;

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      width="100%"
      bg="yellow.300"
      color="black"
      textAlign="center"
      py={1}
      fontWeight="bold"
      fontSize="sm"
      borderBottom="1px dashed"
      borderColor="yellow.600"
      zIndex="9999"
      opacity={0.8}
      pointerEvents="none" // 👈 ensures it doesn't block clicks!
    >
      ⚠️ Testing environment – This is not production
    </Box>
  );
};

export default EnvironmentBanner;